import { Fragment } from 'react';

export function OtherDisclosures() {
  return (
    <Fragment>
      As part of our services, we provide an independent online service which enables you to research and compare financial products or services provided by third parties whilst using this site. Our comparison service is free for you to use, but we may receive a fee and/or commission from the third party product or service providers when you use our service to purchase products or services from them.
    </Fragment>
  );
}


export default OtherDisclosures;
